import React, { Component } from 'react';
import { Col, Row, Card, CardBody, Container, Button, } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { withTranslation } from 'react-i18next';

class GetEventAdverse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            load: false,
            isLoading: false,
            openModal: false,
            dataDiagnostic: [],
            diagnostic: []
        }
    }





    render() {

        const reactTableFoundDiagnostics = {
            tableHeaderData: [{
                Header: 'Codigo',
                accessor: 'codigo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Nombre',
                accessor: 'nombre',
            },
            ],
            tableRowsData: this.state.dataDiagnostic
        };


        return (
            <Container >
                <Row>
                    <Col md={12}>
                        <h3 className="page-title">Análisis de CIOM y SUSAR</h3>
                    </Col>
                </Row>
                <Card >
                    <CardBody style={{ display: 'flex', justifyContent: 'center' }} >
                        <Col md={7} >
                            <div >
                                <form className="material-form" >

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            label="Estudio Clinico"
                                            id="studio-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            defaultValue={null}
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                        </TextField>

                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            required
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-patrocinador"
                                            label="Patrocinador"
                                            type="text"
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>

                                        <TextField
                                            required
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-mfr"
                                            label="MFR Control No."
                                            type="text"
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>

                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <KeyboardDatePicker
                                                label="Fecha de Recepcion"
                                                className="material-form__field"
                                                onChange={(date) => {

                                                }}
                                                format="yyyy/MM/DD"
                                                animateYearScrolling
                                                style={{ width: 300, margin: 15 }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}

                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <KeyboardDatePicker
                                                label="Fecha de Reporte"
                                                className="material-form__field"
                                                onChange={(date) => {

                                                }}
                                                format="yyyy/MM/DD"
                                                animateYearScrolling
                                                style={{ width: 300, margin: 15 }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}

                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', margin: 30 }}>
                                        <div>
                                            <div >
                                                <h4>Tipo de Reporte </h4>
                                            </div>
                                            <div className="form__form-group-field" style={{ marginLeft: 15, }}>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name="type"
                                                        type="radio"
                                                        value={'Inicial'}
                                                        onChange={(e) => {
                                                            //console.log(e.target);

                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Inicial"}</span>
                                                </label>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name="type"
                                                        type="radio"
                                                        value={'Seguimiento'}
                                                        onChange={(e) => {

                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Seguimiento"}</span>
                                                </label>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name="type"
                                                        type="radio"
                                                        value={'Final'}
                                                        onChange={(e) => {

                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Final"}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            label="País"
                                            id="pais-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                        </TextField>


                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            label="Clasificación Evento"
                                            id="clasificacion-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'CIOMS'}>CIOMS</MenuItem>
                                        </TextField>

                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            required
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-sujeto"
                                            label="Id Sujeto"
                                            type="text"
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>


                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                                        <div style={{ marginRight: 10 }} >
                                            <h4>Archivo Adjunto </h4>
                                        </div>

                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'lightgray' }}>

                                        <h4 >Investigador Reportante</h4>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>


                                        <TextField
                                            className="material-form__field"
                                            label="Causalidad del Evento"
                                            id="cause-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                        </TextField>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            label="Desenlace del Evento"
                                            id="desenlace-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'CIOMS'}>CIOMS</MenuItem>
                                        </TextField>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'lightgray' }}>

                                        <h4 >Patrocinador </h4>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>

                                        <TextField
                                            className="material-form__field"
                                            label="Causalidad del Evento"
                                            id="cause-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                        </TextField>

                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'lightgray' }}>

                                        <h4 >Quimico Farmaceutico </h4>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>

                                        <TextField
                                            className="material-form__field"
                                            label="Causalidad del Evento"
                                            id="cause-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                        </TextField>

                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-analisis"
                                            label="Analisis"
                                            multiline
                                            rows={4}
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            disabled
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-profesional"
                                            label="Profesional"
                                            type="text"
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'lightgray' }}>

                                        <h4 >Investigador Principal/ SubInvestigador </h4>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>

                                        <TextField
                                            className="material-form__field"
                                            label="Causalidad del Evento"
                                            id="cause-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {
                                                console.log(event);

                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                        </TextField>

                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-analisis"
                                            label="Analisis"
                                            multiline
                                            rows={4}
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            disabled
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-profesional"
                                            label="Profesional"
                                            type="text"
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            disabled
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-fecha"
                                            label=""
                                            type="text"
                                            placeholder="FECHA:  HORA:"
                                            onChange={(e) => {

                                            }}
                                        />
                                    </div>

                                </form>

                            </div>
                        </Col>
                    </CardBody>
                </Card>
            </Container>
        );

    }
}

export default reduxForm({
    form: `get-event-adverse-form`, // a unique identifier for this form
})(withTranslation('common')(GetEventAdverse));
